const ATTAINMENT_TREND_PERIODS = [
  "last_7_days",
  "last_14_days",
  "last_30_days",
  "last_90_days",
  "last_180_days"
];
function getAttainmentTrendPeriodOffsetDays(period) {
  switch (period) {
    case "last_7_days":
      return 7;
    case "last_14_days":
      return 14;
    case "last_30_days":
      return 30;
    case "last_90_days":
      return 90;
    case "last_180_days":
      return 180;
  }
}
function pickAttainmentTrendMaxPeriod(periods) {
  for (const period of periods) {
    if (getAttainmentTrendPeriodOffsetDays(period) > 30) {
      return "last_180_days";
    }
  }
  return "last_30_days";
}
const DEFAULT_ATTAINMENT_TREND_MAX_PERIOD = "last_30_days";
export {
  ATTAINMENT_TREND_PERIODS,
  DEFAULT_ATTAINMENT_TREND_MAX_PERIOD,
  getAttainmentTrendPeriodOffsetDays,
  pickAttainmentTrendMaxPeriod
};
//# sourceMappingURL=attainmentTrend.js.map
